export default __webpack_public_path__ + "static/banner1-9c7e476b9d3c3d38d7f59e4437139fdb.jpeg";